(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 749px)');
  var GAP = 8;
  var PROTECTED = [
    '.cart__ctas',
    '.cart__footer .tax-note',
    '.cart__footer .totals',
    '.cart__dynamic-checkout-buttons',
    '.cart-item__quantity',
    '.product-form__buttons',
    '.product-form__quantity',
    'quick-add-modal[open] variant-selects',
    'quick-add-modal[open] .quick-add-modal__toggle'
  ].join(',');

  var host = null;
  var current = { x: 0, y: 0 };
  var frame = 0;
  var activatorObserver = null;
  var observedActivator = null;
  var hostObserver = null;
  var observedHostRoot = null;
  var runtimeObserver = null;
  var observedRuntimeRoot = null;
  var geometryObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  var geometryNodes = [];

  function getActivator() {
    if (!host || !host.shadowRoot) return null;
    if (observedHostRoot !== host.shadowRoot) {
      if (hostObserver) hostObserver.disconnect();
      observedHostRoot = host.shadowRoot;
      hostObserver = new MutationObserver(schedule);
      hostObserver.observe(observedHostRoot, { childList: true, subtree: true });
    }
    var runtime = host.shadowRoot.querySelector('shopify-agent-runtime');
    if (!runtime || !runtime.shadowRoot) return null;
    if (observedRuntimeRoot !== runtime.shadowRoot) {
      if (runtimeObserver) runtimeObserver.disconnect();
      observedRuntimeRoot = runtime.shadowRoot;
      runtimeObserver = new MutationObserver(schedule);
      runtimeObserver.observe(observedRuntimeRoot, { childList: true, subtree: true });
    }
    return runtime.shadowRoot.querySelector('button[part="activator"]');
  }

  function setOffset(x, y) {
    if (x === current.x && y === current.y) return;
    current = { x: x, y: y };
    host.style.setProperty('--rck-chat-x', x + 'px');
    host.style.setProperty('--rck-chat-y', y + 'px');
  }

  function intersects(a, b) {
    return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }

  function box(left, top, width, height) {
    return { left: left, top: top, right: left + width, bottom: top + height };
  }

  function inflate(r) {
    return { left: r.left - GAP, top: r.top - GAP, right: r.right + GAP, bottom: r.bottom + GAP };
  }

  function getBounds() {
    var vv = window.visualViewport;
    var width = vv ? vv.width : window.innerWidth;
    var height = vv ? vv.height : window.innerHeight;
    var top = 0;
    var bottom = height;

    var header = document.querySelector('.section-header');
    if (header) {
      var hr = header.getBoundingClientRect();
      if (hr.height > 0 && hr.bottom > 0 && hr.top < height) top = Math.max(top, hr.bottom);
    }

    var preview = document.getElementById('PBarNextFrameWrapper');
    if (preview) {
      var pr = preview.getBoundingClientRect();
      if (pr.height > 0 && pr.top < height && pr.bottom > 0) bottom = Math.min(bottom, pr.top);
    }

    return { left: 0, top: top, right: width, bottom: bottom };
  }

  function getObstacles(viewport, activator) {
    var list = [];
    var modal = document.querySelector('quick-add-modal[open]');
    var nodes = modal
      ? modal.querySelectorAll('.product-form__buttons,.product-form__quantity,variant-selects,.quick-add-modal__toggle')
      : document.querySelectorAll(PROTECTED);
    watchGeometry([document.body, activator].concat(Array.from(nodes)));
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i].getBoundingClientRect();
      if (r.width === 0 || r.height === 0) continue;
      if (r.bottom <= viewport.top || r.top >= viewport.bottom) continue;
      list.push(inflate(r));
    }
    return list;
  }

  function isFree(r, obstacles, bounds) {
    if (r.left < bounds.left + GAP || r.right > bounds.right - GAP) return false;
    if (r.top < bounds.top + GAP || r.bottom > bounds.bottom - GAP) return false;
    for (var i = 0; i < obstacles.length; i++) {
      if (intersects(r, obstacles[i])) return false;
    }
    return true;
  }

  function run() {
    frame = 0;
    var activator = getActivator();
    if (!activator) return;
    watchActivator(activator);

    if (!MQ.matches || activator.getAttribute('aria-expanded') === 'true') {
      watchGeometry([activator]);
      setOffset(0, 0);
      return;
    }

    var rect = activator.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return;

    var w = rect.width;
    var h = rect.height;
    var baseLeft = rect.left - current.x;
    var baseTop = rect.top - current.y;
    var base = box(baseLeft, baseTop, w, h);

    var bounds = getBounds();
    var obstacles = getObstacles({ top: 0, bottom: window.innerHeight }, activator);

    var collides = false;
    for (var i = 0; i < obstacles.length; i++) {
      if (intersects(base, obstacles[i])) { collides = true; break; }
    }
    if (!collides) {
      setOffset(0, 0);
      return;
    }

    var ys = [];
    var xs = [];
    for (var j = 0; j < obstacles.length; j++) {
      ys.push(obstacles[j].top - h, obstacles[j].bottom);
      xs.push(obstacles[j].left - w, obstacles[j].right);
    }

    var best = null;
    function consider(left, top) {
      var r = box(left, top, w, h);
      if (!isFree(r, obstacles, bounds)) return;
      var d = Math.abs(left - baseLeft) + Math.abs(top - baseTop);
      if (!best || d < best.d) best = { x: left - baseLeft, y: top - baseTop, d: d };
    }

    for (var a = 0; a < ys.length; a++) consider(baseLeft, ys[a]);
    if (!best) {
      for (var b = 0; b < xs.length; b++) {
        consider(xs[b], baseTop);
        for (var c = 0; c < ys.length; c++) consider(xs[b], ys[c]);
      }
    }

    if (best) {
      setOffset(Math.round(best.x), Math.round(best.y));
    } else {
      setOffset(0, 0);
    }
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(run);
  }

  function watchGeometry(nodes) {
    if (!geometryObserver) return;
    var next = nodes.filter(function (node, index) {
      return node && node.isConnected && nodes.indexOf(node) === index;
    });
    if (next.length === geometryNodes.length && next.every(function (node, index) {
      return node === geometryNodes[index];
    })) return;
    geometryObserver.disconnect();
    geometryNodes = next;
    geometryNodes.forEach(function (node) { geometryObserver.observe(node); });
  }

  function watchActivator(activator) {
    if (observedActivator === activator) return;
    if (activatorObserver) activatorObserver.disconnect();
    observedActivator = activator;
    activatorObserver = new MutationObserver(schedule);
    activatorObserver.observe(activator, { attributes: true, attributeFilter: ['aria-expanded'] });
  }

  function start(found) {
    host = found;
    window.addEventListener('scroll', schedule, { passive: true, capture: true });
    window.addEventListener('resize', schedule, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule, { passive: true });
      window.visualViewport.addEventListener('scroll', schedule, { passive: true });
    }
    if (MQ.addEventListener) MQ.addEventListener('change', schedule);

    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'hidden', 'aria-expanded']
    });

    if (window.customElements) {
      customElements.whenDefined('shopify-chat').then(schedule);
      customElements.whenDefined('shopify-agent-runtime').then(schedule);
    }
    window.addEventListener('load', schedule, { once: true });
    schedule();
  }

  function init() {
    var found = document.querySelector('shopify-chat');
    if (found) {
      start(found);
      return;
    }
    var waiter = new MutationObserver(function () {
      var el = document.querySelector('shopify-chat');
      if (el) {
        waiter.disconnect();
        start(el);
      }
    });
    waiter.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
